module.exports = function() {
  return new Worker(__webpack_public_path__ + "3861746f5aa278c9c889.worker.js");
};